'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StatusCode;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _smConst = require('../constants/sm-const');

var _smConst2 = _interopRequireDefault(_smConst);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function isConfirmed(reservation) {
  var status = reservation.status,
      startedAt = reservation.started_at;

  return (status === _smConst2.default.ReservationStatus.Confirmed || status === _smConst2.default.ReservationStatus.Paid || status === _smConst2.default.ReservationStatus.Onsite || status === _smConst2.default.ReservationStatus.Invoice || status === _smConst2.default.ReservationStatus.Postpay) && (0, _moment2.default)().diff((0, _moment2.default)(startedAt), 'minutes') < 1;
}

function isPaying(reservation) {
  var status = reservation.status,
      startedAt = reservation.started_at;

  return status === _smConst2.default.ReservationStatus.Paying && (0, _moment2.default)().diff((0, _moment2.default)(startedAt), 'minutes') < 1;
}

function isRequesting(reservation) {
  var status = reservation.status,
      messageClosedAt = reservation.message_closed_at;

  return status === _smConst2.default.ReservationStatus.Requested && Boolean(messageClosedAt) === false;
}

function isInquiry(reservation) {
  var status = reservation.status,
      messageClosedAt = reservation.message_closed_at;

  return (status === _smConst2.default.ReservationStatus.Sent || status === _smConst2.default.ReservationStatus.EntrustedOwner) && Boolean(messageClosedAt) === false;
}

function isCancelled(reservation) {
  var status = reservation.status;

  return status === _smConst2.default.ReservationStatus.Cancelled || status === _smConst2.default.ReservationStatus.OwnerCancelled;
}

function isExpired(reservation) {
  var status = reservation.status,
      messageClosedAt = reservation.message_closed_at;


  return status === _smConst2.default.ReservationStatus.Expired || Boolean(messageClosedAt);
}

function isEnded(reservation) {
  var status = reservation.status,
      startedAt = reservation.started_at;

  return (status === _smConst2.default.ReservationStatus.Ended || status === _smConst2.default.ReservationStatus.Confirmed || status === _smConst2.default.ReservationStatus.Paid || status === _smConst2.default.ReservationStatus.Onsite || status === _smConst2.default.ReservationStatus.Invoice || status === _smConst2.default.ReservationStatus.Postpay || status === _smConst2.default.ReservationStatus.Paying) && (0, _moment2.default)().diff((0, _moment2.default)(startedAt), 'minutes') >= 1;
}

function isRejected(reservation) {
  var status = reservation.status;

  return status === _smConst2.default.ReservationStatus.Rejected;
}

function isOwnerCancelled(reservation) {
  var status = reservation.status;

  return status === _smConst2.default.ReservationStatus.OwnerCancelled;
}

function isSystemCancelled(reservation) {
  var status = reservation.status;

  return status === _smConst2.default.ReservationStatus.SystemCancelled;
}

function isUserCancelled(reservation) {
  var status = reservation.status;

  return status === _smConst2.default.ReservationStatus.CancelSent || status === _smConst2.default.ReservationStatus.Cancelled;
}

function isRefunded(reservation) {
  var status = reservation.status;

  return status === _smConst2.default.ReservationStatus.Refunded;
}

function hasChangeRequestFromOwner(reservation) {
  return reservation.unapproved_reservation;
}

function hasChangeRequestFromUser(reservation) {
  return reservation.unapproved_reservation_from_user;
}

function isStay(reservation) {
  return reservation.rent_type === _smConst2.default.RentType.Stay || reservation.event_type === 'stay';
}

function isActive(reservation) {
  var status = reservation.status,
      startedAt = reservation.started_at;

  switch (status) {
    case _smConst2.default.ReservationStatus.Sent: // お問い合わせ
    case _smConst2.default.ReservationStatus.EntrustedOwner: // 問い合わせベースパターン
    case _smConst2.default.ReservationStatus.Requested: // 予約リクエスト
    case _smConst2.default.ReservationStatus.Confirmed: // 承認済み
    case _smConst2.default.ReservationStatus.CancelSent: // キャンセル送信済
    case _smConst2.default.ReservationStatus.Paid: // 予約完了(支払済)
    case _smConst2.default.ReservationStatus.Paying: // 支払い方法選択（銀行,現地決済,請求書）
    case _smConst2.default.ReservationStatus.Refunded: // 払い戻し済
    case _smConst2.default.ReservationStatus.Onsite: // 現地支払い
    case _smConst2.default.ReservationStatus.Invoice: // 請求書払い
    case _smConst2.default.ReservationStatus.Postpay:
      // 予約完了(後払い)
      // かつまだ利用開始時間前なら
      return !startedAt || (0, _moment2.default)().isBefore((0, _moment2.default)(startedAt));
    default:
      return false;
  }
}

var Status = {
  ACCEPT: 1,
  GUEST_CANCEL: 2,
  HOST_CANCEL: 3,
  DENIAL: 4,
  RESERVED: 5,
  REFUNDED: 6,
  EXPIRED: 7,
  USED: 8,
  PAYING: 9,
  SYSTEM_CANCEL: 14
};

var StatusCode = (_StatusCode = {}, _defineProperty(_StatusCode, _smConst2.default.ReservationStatus.Sent, Status.ACCEPT), _defineProperty(_StatusCode, _smConst2.default.ReservationStatus.EntrustedOwner, Status.ACCEPT), _defineProperty(_StatusCode, _smConst2.default.ReservationStatus.Requested, Status.ACCEPT), _defineProperty(_StatusCode, _smConst2.default.ReservationStatus.Confirmed, Status.ACCEPT), _defineProperty(_StatusCode, _smConst2.default.ReservationStatus.CancelSent, Status.GUEST_CANCEL), _defineProperty(_StatusCode, _smConst2.default.ReservationStatus.Cancelled, Status.GUEST_CANCEL), _defineProperty(_StatusCode, _smConst2.default.ReservationStatus.OwnerCancelled, Status.HOST_CANCEL), _defineProperty(_StatusCode, _smConst2.default.ReservationStatus.Rejected, Status.DENIAL), _defineProperty(_StatusCode, _smConst2.default.ReservationStatus.Paid, Status.RESERVED), _defineProperty(_StatusCode, _smConst2.default.ReservationStatus.Paying, Status.PAYING), _defineProperty(_StatusCode, _smConst2.default.ReservationStatus.Refunded, Status.REFUNDED), _defineProperty(_StatusCode, _smConst2.default.ReservationStatus.Onsite, Status.ACCEPT), _defineProperty(_StatusCode, _smConst2.default.ReservationStatus.Invoice, Status.RESERVED), _defineProperty(_StatusCode, _smConst2.default.ReservationStatus.Expired, Status.EXPIRED), _defineProperty(_StatusCode, _smConst2.default.ReservationStatus.SystemCancelled, Status.SYSTEM_CANCEL), _defineProperty(_StatusCode, _smConst2.default.ReservationStatus.Ended, Status.USED), _defineProperty(_StatusCode, _smConst2.default.ReservationStatus.Postpay, Status.ACCEPT), _StatusCode);

var SubStatusCode = {
  REQUEST: 1,
  CHANGE_REQUEST: 2,
  NOT_REPLY: 3,
  NOT_REVIEW: 4,
  CANCEL: 5
};

function getSubStatusCodes(reservation) {
  var statusCodes = [];
  // 承認・否認待ち
  if (isRequesting(reservation)) {
    statusCodes.push(SubStatusCode.REQUEST);
  }
  // 予約変更リクエストあり
  if (reservation.unapproved_reservation_from_user) {
    statusCodes.push(SubStatusCode.CHANGE_REQUEST);
  }
  // 未返信
  if (reservation.message_reader === 'Owner') {
    statusCodes.push(SubStatusCode.NOT_REPLY);
  }
  // キャンセル料金確定待ち
  if (reservation.status === _smConst2.default.ReservationStatus.CancelSent) {
    statusCodes.push(SubStatusCode.CANCEL);
  }

  return statusCodes;
}

exports.default = {
  isConfirmed: isConfirmed,
  isRequesting: isRequesting,
  isInquiry: isInquiry,
  isExpired: isExpired,
  isEnded: isEnded,
  isRejected: isRejected,
  isOwnerCancelled: isOwnerCancelled,
  isSystemCancelled: isSystemCancelled,
  isCancelled: isCancelled,
  isRefunded: isRefunded,
  isPaying: isPaying,
  hasChangeRequestFromOwner: hasChangeRequestFromOwner,
  hasChangeRequestFromUser: hasChangeRequestFromUser,
  getSubStatusCodes: getSubStatusCodes,
  SubStatusCode: SubStatusCode,
  Status: Status,
  StatusCode: StatusCode,
  isStay: isStay,
  isUserCancelled: isUserCancelled,
  isActive: isActive
};


//////////////////
// WEBPACK FOOTER
// ./~/frontend_core/dist/model/Reservation.js
// module id = 104
// module chunks = 0